export default __webpack_public_path__ + "static/dataagreement.aba3b4a8-b7cc57ce216459bd592de227ff5c16f5.pdf";